import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import LazyLoader from "./LazyLoader";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import Swal from "sweetalert2";
import POServices from "../../../services/PoServices";
import LocationServices from "../../../services/LocationServices";
import AccountServices from "../../../services/AccountServices";
import getRequisitionPrintTemplate from "./getRequisitionPrintTemplate";
import getMRVPrintTemplate from "./getMRVPrintTemplate";
import Loader from '../Loader/loader'
import Pagination from "../Pagenation/Pagenation";
const FilePreviewModal = React.lazy(() => import("./FilePreviewModal"));
const AccountPOModal = React.lazy(() => import("./AccountPOModal"));
const MRVPreviewModal = React.lazy(() => import("./MRVPreviewModal"));
const BillingApprovalModal = React.lazy(() => import("./BillingApprovalModal"));
const PaymentHistoryModal = React.lazy(() => import("./PaymentHistoryModal"));
const PoRevisionPrintModal = React.lazy(() => import("../PO/PoRevisionPrintModal"));


const BillingTeam = () => {

    // ==========================================
    // CURRENT USER ROLE
    // ==========================================
    const userDetails = useMemo(() => {
        try {
            return JSON.parse(
                localStorage.getItem("userDetails")
            );
        } catch (error) {
            return null;
        }
    }, []);

    const userRole =
        userDetails?.data?.user?.role
            ?.toLowerCase() || "";

    const isPORole =
        userRole === "pomaker" ||
        userRole === "pochecker";

    // ==========================================
    // ROLE BASED PAYMENT VIEW
    // ==========================================
    const defaultPaymentView =
        isPORole
            ? "poPending"
            : "new";

    // ==========================================
    // ROLE BASED DASHBOARD HEADING
    // ==========================================
    const dashboardHeading =
        userRole === "billing"
            ? "Billing Payment Dashboard"
            : userRole === "pomaker"
                ? "PO Maker Payment Dashboard"
                : userRole === "pochecker"
                    ? "PO Checker Payment Dashboard"
                    : "Payment Dashboard";

    useEffect(() => {

        console.log("BillingTeam Mounted");

        return () => {
            console.log("BillingTeam Unmounted");
        };

    }, []);
    const [open2, setOpen2] = useState(true);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(true);
    const [open, setOpen] = useState(false);
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [storeOptions, setStoreOptions] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
    const [showPOModal, setShowPOModal] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [selectedPO, setSelectedPO] = useState(null);
    const [supplierLoading, setSupplierLoading] = useState(false);
    const [storeLoading, setStoreLoading] = useState(false);
    const [showReqPreview, setShowReqPreview] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [billingModalLoading, setBillingModalLoading] = useState(false);
    const [reqHtml, setReqHtml] = useState("");
    const [overlayLoading] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [selectedHistoryPoId, setSelectedHistoryPoId] = useState(null);
    const [tableLoading, setTableLoading] = useState(false);
    const [poData, setPoData] = useState(null);
    // ==========================================
    // PO PRINT / REVISION PREVIEW
    // ==========================================

    const [showPOPrintModal, setShowPOPrintModal] = useState(false);
    const [selectedPrintPO, setSelectedPrintPO] = useState(null);
    const [printLoadingId, setPrintLoadingId] = useState("");

    const [sortConfig, setSortConfig] = useState({
        key: "",
        direction: "asc"
    });

    const [filters, setFilters] = useState({
        billNo: "",
        supplier: [],
        po: "",
        amount: "",
        amountCriteria: "",

        // PO CREATION DATE
        fromDate: "",
        toDate: "",

        // BILL DATE
        billingFromDate: "",
        billingToDate: "",

        store: ""
    });

    // Filter popup local/form values.
    // Typing here should NOT change the actual search filters.
    const [filterForm, setFilterForm] = useState({
        billNo: "",
        supplier: [],
        po: "",
        amount: "",
        amountCriteria: "",
        fromDate: "",
        toDate: "",
        billingFromDate: "",
        billingToDate: "",
        store: ""
    });

    const [activeFilterKey, setActiveFilterKey] = useState(null);
    const [tableData, setTableData] = useState([]);

    // ==========================================
    // SERVER SIDE PAGINATION
    // ==========================================
    const [activePage, setActivePage] = useState(0); // UI = 0 based
    const [pageLimit, setPageLimit] = useState(50);
    const [totalResults, setTotalResults] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const [isAtEnd, setIsAtEnd] = useState(false);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [supplierFilterUI, setSupplierFilterUI] = useState("");
    const [storeFilterUI, setStoreFilterUI] = useState("");
    const [poTypeFilterUI, setPoTypeFilterUI] = useState("");
    const [showMRVPreview, setShowMRVPreview] = useState(false);
    const [mrvHtml, setMrvHtml] = useState("");



    useEffect(() => {
        fetchSuppliers();
        fetchStores();
    }, []);

    const fetchSuppliers = async () => {
        try {
            setSupplierLoading(true); // 🔥 START LOADING

            const res = await POServices.activeSuppliers();

            const supplierList =
                res?.data?.data || res?.data || [];

            const formatted = supplierList.map(s => ({
                value: s._id,
                label: s.name
            }));

            setSupplierOptions(formatted);

        } catch (err) {
            console.error("Supplier Error:", err);
            Swal.fire("Error", "Failed to load suppliers", "error");
        } finally {
            setSupplierLoading(false); // 🔥 STOP LOADING
        }
    };

    const fetchStores = async () => {
        try {
            setStoreLoading(true);

            const res = await LocationServices.getStore();

            const formatted = (res?.data?.data || []).map(s => ({
                value: s._id,
                label: s.name
            }));

            setStoreOptions(formatted);

        } catch (err) {
            console.error(err);
        } finally {
            setStoreLoading(false);
        }
    };

    const fetchData = async (customPayload = null) => {
        try {
            setTableLoading(true);

            let payload = customPayload
                ? { ...customPayload }
                : { ...filters };

            payload.amount =
                payload.amount
                    ? Number(payload.amount)
                    : "";

            // ==========================================
            // BILLING VIEW
            // ==========================================
            // Default page load  -> new
            // Manual search      -> paymentSearch
            payload.viewType =
                customPayload?.viewType ||
                defaultPaymentView;

            // ==========================================
            // SERVER SIDE PAGINATION
            // ==========================================
            payload.page =
                customPayload?.page ||
                (activePage + 1);

            payload.limit =
                customPayload?.limit ||
                pageLimit;
            // ==========================================
            // MAIN TABLE GLOBAL FILTERS
            // ==========================================

            payload.search =
                customPayload?.search ?? search;

            payload.statusFilter =
                customPayload?.statusFilter ?? statusFilter;

            payload.supplierFilter =
                customPayload?.supplierFilter ?? supplierFilterUI;

            payload.storeFilter =
                customPayload?.storeFilter ?? storeFilterUI;

            payload.poTypeFilter =
                customPayload?.poTypeFilter ?? poTypeFilterUI;


            const res =
                await AccountServices.getBillingDataBySearch(payload);


            // CURRENT PAGE DATA ONLY
            const receivedData = res?.data || [];

            setTableData(receivedData);


            // TOTAL RECORDS FROM BACKEND
            setTotalResults(
                Number(res?.totalResults) || 0
            );

            // TOTAL PAGES FROM BACKEND
            setTotalPages(
                Number(res?.totalPages) || 0
            );

        } catch (err) {
            console.error(
                "BILLING FETCH ERROR:",
                err
            );
        } finally {
            setTableLoading(false);
            setIsFirstLoad(false);
        }
    };
    // ==========================================
    // SERVER SIDE PAGE CHANGE
    // ==========================================
    const handlePageChange = async (page) => {

        setActivePage(page);

        const nextPage =
            page + 1; // UI 0-based -> Backend 1-based

        if (isSearched) {

            // SEARCH RESULT PAGINATION
            await fetchData({
                ...filters,
                viewType: "paymentSearch",
                page: nextPage,
                limit: pageLimit
            });

        } else {

            // ROLE BASED NORMAL PAGINATION
            await fetchData({
                viewType: defaultPaymentView,
                page: nextPage,
                limit: pageLimit
            });

        }
    };
    // ==========================================
    // MAIN TABLE GLOBAL FILTER CHANGE
    // ==========================================
    const handleMainTableFilter = async (
        filterName,
        value
    ) => {

        // ALWAYS RETURN TO FIRST PAGE
        setActivePage(0);

        const globalFilters = {
            search,
            statusFilter,
            supplierFilter: supplierFilterUI,
            storeFilter: storeFilterUI,
            poTypeFilter: poTypeFilterUI,

            // CURRENT CHANGED FILTER
            [filterName]: value
        };


        // ==========================================
        // UPDATE LOCAL UI STATE
        // ==========================================

        if (filterName === "search") {
            setSearch(value);
        }

        if (filterName === "statusFilter") {
            setStatusFilter(value);
        }

        if (filterName === "supplierFilter") {
            setSupplierFilterUI(value);
        }

        if (filterName === "storeFilter") {
            setStoreFilterUI(value);
        }

        if (filterName === "poTypeFilter") {
            setPoTypeFilterUI(value);
        }


        // ==========================================
        // BACKEND GLOBAL FILTER
        // ==========================================

        await fetchData({
            ...(isSearched ? filters : {}),

            viewType:
                isSearched
                    ? "paymentSearch"
                    : defaultPaymentView,

            page: 1,
            limit: pageLimit,

            ...globalFilters
        });
    };
    // ==========================================
    // MAIN SEARCH - DEBOUNCE
    // ==========================================
    useEffect(() => {

        // Do not search immediately while user is typing
        const timer = setTimeout(() => {

            setActivePage(0);

            fetchData({
                ...(isSearched ? filters : {}),

                viewType:
                    isSearched
                        ? "paymentSearch"
                        : defaultPaymentView,

                page: 1,
                limit: pageLimit,

                search: search,
                statusFilter: statusFilter,
                supplierFilter: supplierFilterUI,
                storeFilter: storeFilterUI,
                poTypeFilter: poTypeFilterUI
            });

        }, 500);

        return () => clearTimeout(timer);

    }, [search]);

    useEffect(() => {
        fetchData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const handleSearch = async () => {

        const isEmptySearch =
            !filters.fromDate &&
            !filters.toDate &&
            !filters.billingFromDate &&
            !filters.billingToDate &&
            !filters.po &&
            !filters.billNo &&
            !filters.amount &&
            !filters.amountCriteria &&
            (!filters.supplier || filters.supplier.length === 0) &&
            !filters.store;

        if (isEmptySearch) {
            Swal.fire(
                "Select Filter",
                "Please select at least one criteria before searching",
                "warning"
            );
            return;
        }
        // ======================================
        // PO CREATION DATE VALIDATION
        // ======================================

        if (
            (filters.fromDate && !filters.toDate) ||
            (!filters.fromDate && filters.toDate)
        ) {
            Swal.fire(
                "PO Creation Date",
                "Please select both From Date and To Date.",
                "warning"
            );
            return;
        }

        if (
            filters.fromDate &&
            filters.toDate &&
            filters.fromDate > filters.toDate
        ) {
            Swal.fire(
                "PO Creation Date",
                "From Date cannot be greater than To Date.",
                "warning"
            );
            return;
        }
        // ======================================
        // BILL DATE VALIDATION
        // ======================================

        if (
            (filters.billingFromDate && !filters.billingToDate) ||
            (!filters.billingFromDate && filters.billingToDate)
        ) {
            Swal.fire(
                "Bill Date",
                "Please select both From Date and To Date.",
                "warning"
            );
            return;
        }

        if (
            filters.billingFromDate &&
            filters.billingToDate &&
            filters.billingFromDate > filters.billingToDate
        ) {
            Swal.fire(
                "Bill Date",
                "From Date cannot be greater than To Date.",
                "warning"
            );
            return;
        }

        // 🔥 EXISTING AMOUNT VALIDATION (UNCHANGED)
        if (
            (filters.amount && !filters.amountCriteria) ||
            (!filters.amount && filters.amountCriteria)
        ) {
            Swal.fire("Amount Filter", "Please select criteria and enter amount", "warning");
            return;
        }

        try {
            setActivePage(0);

            await fetchData({
                ...filters,
                viewType: "paymentSearch",
                page: 1,
                limit: pageLimit
            });

            setIsSearched(true);
            setOpen(false);

        } catch (err) {
            console.error(err);
        } finally {
        }
    };

    const formatDateTime = (date) => {
        if (!date) return "-";
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")
            }/${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")
            }:${String(d.getMinutes()).padStart(2, "0")}:${String(d.getSeconds()).padStart(2, "0")
            }`;
    };

  const getStatusLabel = (paymentFlowStatus) => {

    const map = {
        "Not-Started": "Billing Pending",
        "PO-Validation-Pending": "PO Validation Pending",
        "HO-Approval-Pending": "HO Approval Pending",
        "Accounts-Pending": "Accounts Pending",
        "Payment-Pending": "Payment Pending",
        "Partially-Paid": "Partially Paid",
        "Payment-Completed": "Payment Completed",
        "Closed": "Closed",

        "Sent-Back-To-Billing": "Sent Back To Billing",
        "Sent-Back-To-PO": "Sent Back To PO",
        "Sent-Back-To-HO": "Sent Back To HO"
    };

    // If backend did not return paymentFlowStatus,
    // show the correct status according to current role/view.
    if (!paymentFlowStatus) {
        return isPORole
            ? "PO Validation Pending"
            : "Billing Pending";
    }

    return (
        map[paymentFlowStatus] ||
        paymentFlowStatus
    );
};



    const handleRequisitionPreview = async (requisitionId) => {
        try {
            setShowReqPreview(true);
            setReqHtml("");

            const res = await AccountServices.getItemsByRequisitionId(requisitionId);

            // ✅ FIXED
            const finalData = res?.data;

            if (!finalData) {
                throw new Error("No data found");
            }

            const htmlContent = getRequisitionPrintTemplate(finalData);

            setReqHtml(htmlContent);

        } catch (err) {
            console.error(err);
            setShowReqPreview(false);
            Swal.fire("Error", "Failed to load Requisition", "error");
        }
    };
    const handleFailedRequisitionPreview = async (requisitionId, poNumber) => {
        try {
            setShowReqPreview(true);
            setReqHtml("");

            const res = await AccountServices.getItemsByRequisitionId(requisitionId);

            const finalData = res?.data;

            if (!finalData) {
                throw new Error("No data found");
            }

            // 🔥 FILTER ONLY FAILED ITEMS
            const filteredItems = (finalData.items || []).filter(item =>
                item.status === "supplier_failed" &&
                String(item.poNumber) === String(poNumber)
            );

            // 🔥 CREATE NEW OBJECT (KEEP SAME STRUCTURE)
            const modifiedData = {
                ...finalData,
                items: filteredItems
            };

            // ❗ IF NO FAILED ITEMS
            if (filteredItems.length === 0) {
                Swal.fire("No Failed Items", "No supplier failed items found for this PO", "info");
            }

            const htmlContent = getRequisitionPrintTemplate(modifiedData);

            setReqHtml(htmlContent);

        } catch (err) {
            console.error(err);
            setShowReqPreview(false);
            Swal.fire("Error", "Failed to load Failed Requisition", "error");
        }
    };
    const handleMRVPreview = async (mrvId) => {
        try {
            // ✅ STEP 1: OPEN MODAL IMMEDIATELY
            setShowMRVPreview(true);
            setMrvHtml(""); // 🔥 triggers loader inside modal

            // ❌ REMOVE Swal loader completely

            // ✅ STEP 2: CALL API
            const res = await AccountServices.getMRVDataByTheMRVId([mrvId]);

            const finalData = res?.data?.[0]; // ✅ FIXED PATH


            const htmlContent = getMRVPrintTemplate(finalData);

            // ✅ STEP 3: SET DATA (loader disappears automatically)
            setMrvHtml(htmlContent);

        } catch (err) {
            console.error(err);
            setShowMRVPreview(false); // ✅ close modal if error
            Swal.fire("Error", "Failed to load MRV", "error");
        }
    };
    const handleMultiMRVPreview = async (mrvIds) => {
        try {
            // ✅ open modal + loader
            setShowMRVPreview(true);
            setMrvHtml("");

            const res = await AccountServices.getMRVDataByTheMRVId(mrvIds);

            const allData = res?.data || [];

            // ✅ merge all MRVs into ONE HTML
            const mergedHTML = `
      <html>
      <head>
        <title>All MRVs</title>
        <style>
          .page-break {
            page-break-after: always;
          }
        </style>
      </head>
      <body>
        ${allData
                    .map((mrv, index) => `
            <div>
              ${getMRVPrintTemplate(mrv)}
            </div>
            ${index !== allData.length - 1 ? `<div class="page-break"></div>` : ""}
          `)
                    .join("")}
      </body>
      </html>
    `;

            setMrvHtml(mergedHTML);

        } catch (err) {
            console.error(err);
            setShowMRVPreview(false);
            Swal.fire("Error", "Failed to load MRVs", "error");
        }
    };

    const handleBillPreview = (mrv) => {
        if (!mrv?.image) {
            Swal.fire("No File", "No document available", "info");
            return;
        }

        const baseUrl = "https://indigoinfra.in";
        const folder = "/img/mrv/";

        const fullUrl = `${baseUrl}${folder}${mrv.image}`;

        console.log("Preview URL:", fullUrl); // 🔥 DEBUG

        setPreviewFile({ url: fullUrl });
        setShowPreview(true);
    };

    const handleMultiBillPreview = (mrvDetails) => {
        try {
            setShowPreview(true);
            setPreviewFile(null); // 🔥 trigger loader

            const baseUrl = "https://indigoinfra.in";
            const folder = "/img/mrv/";

            // ✅ remove duplicate + invalid
            const uniqueMap = new Map();

            mrvDetails.forEach(m => {
                if (m?.image) {
                    uniqueMap.set(m.image, m);
                }
            });

            const validFiles = Array.from(uniqueMap.values());

            // ❌ no files case
            if (validFiles.length === 0) {
                Swal.fire("No Files", "No bills available", "info");
                setShowPreview(false);
                return;
            }

            // ✅ CREATE FILE ARRAY (FINAL)
            const files = validFiles.map(m => ({
                url: `${baseUrl}${folder}${m.image}`,
                type: m.image.toLowerCase().includes(".pdf") ? "pdf" : "image"
            }));

            // 🔥 IMPORTANT: ONLY THIS (NO HTML)
            setPreviewFile({ files });

        } catch (err) {
            console.error(err);
            setShowPreview(false);
            Swal.fire("Error", "Failed to load bills", "error");
        }
    };

    const handleOtherDocPreview = (mrv) => {
        if (!mrv?.otherDoc) {
            Swal.fire("Not Available", "No document available", "info");
            return;
        }

        Swal.fire({
            title: "Loading Preview...",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        const baseUrl = "https://indigoinfra.in";
        const fullUrl = `${baseUrl}/img/billing/${mrv.otherDoc}`;

        setPreviewFile({ url: fullUrl });

        setTimeout(() => {
            setShowPreview(true);
            Swal.close();
        }, 300);
    };

    const sortedData = [...tableData].sort((a, b) => {

        if (!sortConfig.key) return 0;

        let valA;
        let valB;

        if (sortConfig.key === "createdAt") {
            valA = a.createdAt
                ? new Date(a.createdAt)
                : new Date(0);

            valB = b.createdAt
                ? new Date(b.createdAt)
                : new Date(0);
        }

        else if (sortConfig.key === "updatedAt") {
            valA = a.updatedAt
                ? new Date(a.updatedAt)
                : new Date(0);

            valB = b.updatedAt
                ? new Date(b.updatedAt)
                : new Date(0);
        }

        // ✅ BILL DATE
        else if (sortConfig.key === "billingDate") {

            valA = a?.mrvDetails?.[0]?.billingDate
                ? new Date(a.mrvDetails[0].billingDate)
                : new Date(0);

            valB = b?.mrvDetails?.[0]?.billingDate
                ? new Date(b.mrvDetails[0].billingDate)
                : new Date(0);
        }

        // ✅ PO AMOUNT
        else if (sortConfig.key === "totalAmount") {
            valA = Number(a.totalAmount || 0);
            valB = Number(b.totalAmount || 0);
        }

        // ✅ PO NUMBER
        else if (sortConfig.key === "poNumber") {
            valA = Number(a.poNumber || 0);
            valB = Number(b.poNumber || 0);
        }

        // 🔥 ✅ FAILED SUPPLY COUNT (NEW)
        else if (sortConfig.key === "failedSupplyCount") {
            valA = Number(a.failedSupplyCount || 0);
            valB = Number(b.failedSupplyCount || 0);
        }

        // 🔥 ✅ BILL AMOUNT (SUM OF MRVs)
        else if (sortConfig.key === "billAmount") {
            valA = (a.mrvDetails || []).reduce(
                (sum, m) => sum + Number(m.totalAmount || 0),
                0
            );

            valB = (b.mrvDetails || []).reduce(
                (sum, m) => sum + Number(m.totalAmount || 0),
                0
            );
        }

        // 🔥 ✅ OTHER CHARGES (SUM OF MRVs)
        else if (sortConfig.key === "otherCharges") {
            valA = (a.mrvDetails || []).reduce(
                (sum, m) => sum + Number(m.otherCharges || 0),
                0
            );

            valB = (b.mrvDetails || []).reduce(
                (sum, m) => sum + Number(m.otherCharges || 0),
                0
            );
        }

        // ✅ DEFAULT
        else {
            valA = a[sortConfig.key];
            valB = b[sortConfig.key];
        }

        // ✅ FINAL COMPARE
        if (valA < valB) {
            return sortConfig.direction === "asc" ? -1 : 1;
        }

        if (valA > valB) {
            return sortConfig.direction === "asc" ? 1 : -1;
        }

        return 0;
    });
    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction:
                prev.key === key && prev.direction === "asc" ? "desc" : "asc"
        }));
    };

    const supplierOptionsUI = useMemo(() => {
        return supplierOptions
            .map(item => item.label)
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b));
    }, [supplierOptions]);

    const storeOptionsUI = useMemo(() => {
        return storeOptions
            .map(item => item.label)
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b));
    }, [storeOptions]);

    const statusOptionsUI = useMemo(() => [
        ...new Set(
            sortedData
                .map(item =>
                    getStatusLabel(
                        item.paymentFlowStatus
                    )
                )
                .filter(Boolean)
        )
    ], [tableData, sortConfig]);

    const poTypeOptionsUI = [
        "Normal",
        "FOC PO",
        "Advance Payment"
    ];

    const filteredData = useMemo(() => {

        return [...tableData].sort((a, b) => {

            if (!sortConfig.key) return 0;

            let valA;
            let valB;

            // CREATED DATE
            if (sortConfig.key === "createdAt") {
                valA = a.createdAt
                    ? new Date(a.createdAt)
                    : new Date(0);

                valB = b.createdAt
                    ? new Date(b.createdAt)
                    : new Date(0);
            }

            // UPDATED DATE
            else if (sortConfig.key === "updatedAt") {
                valA = a.updatedAt
                    ? new Date(a.updatedAt)
                    : new Date(0);

                valB = b.updatedAt
                    ? new Date(b.updatedAt)
                    : new Date(0);
            }

            // BILL DATE
            else if (sortConfig.key === "billingDate") {

                valA = a?.mrvDetails?.[0]?.billingDate
                    ? new Date(a.mrvDetails[0].billingDate)
                    : new Date(0);

                valB = b?.mrvDetails?.[0]?.billingDate
                    ? new Date(b.mrvDetails[0].billingDate)
                    : new Date(0);
            }

            // PO AMOUNT
            else if (sortConfig.key === "totalAmount") {
                valA = Number(a.totalAmount || 0);
                valB = Number(b.totalAmount || 0);
            }

            // PO NUMBER
            else if (sortConfig.key === "poNumber") {
                valA = Number(a.poNumber || 0);
                valB = Number(b.poNumber || 0);
            }

            // BILL AMOUNT
            else if (sortConfig.key === "billAmount") {

                valA = (a.mrvDetails || []).reduce(
                    (sum, m) => sum + Number(m.totalAmount || 0),
                    0
                );

                valB = (b.mrvDetails || []).reduce(
                    (sum, m) => sum + Number(m.totalAmount || 0),
                    0
                );
            }

            // OTHER CHARGES
            else if (sortConfig.key === "otherCharges") {

                valA = (a.mrvDetails || []).reduce(
                    (sum, m) => sum + Number(m.otherCharges || 0),
                    0
                );

                valB = (b.mrvDetails || []).reduce(
                    (sum, m) => sum + Number(m.otherCharges || 0),
                    0
                );
            }

            // DELIVERY FAILED
            else if (sortConfig.key === "failedSupplyCount") {
                valA = Number(a.failedSupplyCount || 0);
                valB = Number(b.failedSupplyCount || 0);
            }

            // DEFAULT
            else {
                valA = a[sortConfig.key];
                valB = b[sortConfig.key];
            }

            // FINAL ASC / DESC
            if (valA < valB) {
                return sortConfig.direction === "asc" ? -1 : 1;
            }

            if (valA > valB) {
                return sortConfig.direction === "asc" ? 1 : -1;
            }

            return 0;
        });

    }, [tableData, sortConfig]);

    const handleFilterChange = (key, value, setter) => {

        // ✅ update filter directly
        setter(value);

        // ✅ optional tracking only
        if (
            value === "" ||
            value === null ||
            value === 0 ||
            (Array.isArray(value) && value.length === 0)
        ) {
            if (activeFilterKey === key) {
                setActiveFilterKey(null);
            }
        } else {
            setActiveFilterKey(key);
        }
    };

    const handlePOClick = async (item) => {
        const poId =
            item?.poId ||
            item?.po?._id ||
            item?._id;

        if (!poId) {
            Swal.fire(
                "Error",
                "Purchase Order ID is missing.",
                "error"
            );
            return;
        }

        // prevent multiple clicks
        if (printLoadingId) {
            return;
        }

        try {
            setPrintLoadingId(String(poId));

            // clear previous PO
            setSelectedPrintPO(null);

            // ==========================================
            // SAME API USED IN PO MANAGEMENT
            // ==========================================
            const response =
                await POServices.getPurchaseOrderPrintHistory(poId);

            const printData =
                response?.data?.data ||
                response?.data ||
                null;

            const versions =
                Array.isArray(printData?.versions)
                    ? printData.versions
                    : [];

            if (!printData) {
                Swal.fire(
                    "Print Data Missing",
                    "Purchase Order print data was not found.",
                    "warning"
                );
                return;
            }

            if (!versions.length) {
                Swal.fire(
                    "No PO Versions",
                    "Original or revised Purchase Order versions were not found.",
                    "warning"
                );
                return;
            }

            setSelectedPrintPO(printData);
            setShowPOPrintModal(true);

        } catch (error) {

            console.error(
                "BILLING PO PRINT ERROR:",
                error
            );

            Swal.fire(
                "Error",
                error?.response?.data?.message ||
                error?.message ||
                "Unable to load Purchase Order print history.",
                "error"
            );

        } finally {

            setPrintLoadingId("");
        }
    };


    const handleBillingApproveClick = (item) => {

        // Show full-screen loader immediately
        setBillingModalLoading(true);

        // Set selected PO/item
        setSelectedItem(item);

        // Open modal - child will tell us when data is ready
        setShowApproveModal(true);
    };

    const isDefaultView =
        !filters.fromDate &&
        !filters.toDate &&
        !filters.billingFromDate &&
        !filters.billingToDate &&
        !filters.po &&
        !filters.billNo &&
        !filters.amount &&
        !filters.amountCriteria &&
        (!filters.supplier || filters.supplier.length === 0) &&
        !filters.store;

    const scrollTable = (direction) => {
        const container = document.getElementById("billingTableScroll");
        if (!container) return;

        const scrollAmount = 300;

        container.scrollBy({
            left: direction === "right" ? scrollAmount : -scrollAmount,
            behavior: "smooth"
        });
    };

    const checkScrollEnd = (container) => {
        const scrollLeft = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;

        const atStart = scrollLeft <= 5;
        const atEnd = scrollLeft >= maxScroll - 5;

        setShowLeft(!atStart);
        setShowRight(!atEnd);
        setIsAtEnd(atEnd);
    };

    useEffect(() => {
        const container = document.getElementById("billingTableScroll");

        if (!container) return;

        checkScrollEnd(container); // 🔥 initial check

        const handleScroll = () => checkScrollEnd(container);

        container.addEventListener("scroll", handleScroll);

        return () => container.removeEventListener("scroll", handleScroll);
    }, [tableData]);


    const handleHistoryClick = (poId) => {

        if (!poId) return;

        setSelectedHistoryPoId(poId);
        setShowHistoryModal(true);

    };


    return (
        <>
            {/* BILLING APPROVAL MODAL FULL SCREEN LOADER */}
            {billingModalLoading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(255,255,255,0.92)",
                        zIndex: 999999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <Loader />
                </div>
            )}

            {/* ==========================================
        PO PREVIEW LOADER
    ========================================== */}
            {printLoadingId && (
                <Loader />
            )}
            {/* FILE PREVIEW */}
            <React.Suspense fallback={<LazyLoader text="Loading Preview..." />}>
                {showPreview && (
                    <FilePreviewModal
                        show={showPreview}
                        handleClose={() => setShowPreview(false)}
                        file={previewFile}
                    />
                )}
            </React.Suspense>
            {/* REQUISITION PREVIEW */}
            <React.Suspense fallback={null}>
                {showReqPreview && (
                    <MRVPreviewModal
                        show={showReqPreview}
                        onClose={() => setShowReqPreview(false)}
                        htmlContent={reqHtml}
                        documentType="REQUISITION"

                    />
                )}
            </React.Suspense>

            {/* MRV PREVIEW */}
            <React.Suspense fallback={<LazyLoader text="Loading MRV..." />}>
                {showMRVPreview && (
                    <MRVPreviewModal
                        show={showMRVPreview}
                        onClose={() => setShowMRVPreview(false)}
                        htmlContent={mrvHtml}
                    />
                )}
            </React.Suspense>

            {/* ==========================================
    PO PRINT / REVISION PREVIEW
========================================== */}
            <React.Suspense
                fallback={
                    <LazyLoader text="Loading PO..." />
                }
            >
                {selectedPrintPO && (
                    <PoRevisionPrintModal
                        show={showPOPrintModal}
                        onHide={() => {
                            setShowPOPrintModal(false);
                            setSelectedPrintPO(null);
                        }}
                        printHistory={selectedPrintPO}
                    />
                )}
            </React.Suspense>

            <React.Suspense fallback={null}>
                {showApproveModal && (
                    <BillingApprovalModal
                        show={showApproveModal}
                        onInitialLoadComplete={() => {
                            setBillingModalLoading(false);
                        }}
                        handleClose={async () => {

                            // Always stop Approval Modal loader on close
                            setBillingModalLoading(false);

                            // Close Approval Modal
                            setShowApproveModal(false);

                            // Clear selected item
                            setSelectedItem(null);

                            // Refresh Billing Dashboard
                            await fetchData();

                        }}
                        selectedItem={selectedItem}

                        onUpdateMrv={(updatedMrv) => {

                            // 🔥 UPDATE MAIN TABLE DATA
                            const updatedTable = tableData.map(item => {
                                if (
                                    String(item.poId) !==
                                    String(selectedItem.poId)
                                ) {
                                    return item;
                                }

                                const updatedMrvList = item.mrvDetails.map(m =>
                                    m._id === updatedMrv._id ? updatedMrv : m
                                );

                                return {
                                    ...item,
                                    mrvDetails: updatedMrvList
                                };
                            });

                            setTableData(updatedTable);

                            // 🔥 ALSO UPDATE SELECTED ITEM (MODAL)
                            const updatedSelected = {
                                ...selectedItem,
                                mrvDetails: selectedItem.mrvDetails.map(m =>
                                    m._id === updatedMrv._id ? updatedMrv : m
                                )
                            };

                            setSelectedItem(updatedSelected);
                        }}

                        onUpdateBilling={(updatedBilling) => {

                            const updatedPoId =
                                updatedBilling?.poId ||
                                updatedBilling?._id;

                            const updatedTable = tableData.map(item => {

                                if (
                                    String(item.poId) !==
                                    String(updatedPoId)
                                ) {
                                    return item;
                                }

                                return {
                                    ...item,
                                    ...updatedBilling,
                                    poId: item.poId
                                };
                            });

                            setTableData(updatedTable);

                            setSelectedItem(prev => ({
                                ...prev,
                                ...updatedBilling,
                                poId: prev?.poId
                            }));
                        }}

                        // 🔥 NEW CALLBACK (ONLY FOR APPROVE)
                        onApproveSuccess={async (approvedItem) => {

                            setTableData(prev =>
                                prev.filter(item =>
                                    String(item.poId) !== String(approvedItem.poId)
                                )
                            );

                            await fetchData();
                        }}

                        handlePOClick={handlePOClick}
                        handleMRVPreview={handleMRVPreview}
                        handleMultiMRVPreview={handleMultiMRVPreview}
                        handleBillPreview={handleBillPreview}
                        handleMultiBillPreview={handleMultiBillPreview}
                        handleRequisitionPreview={handleRequisitionPreview}

                    />
                )}
            </React.Suspense>

            {/* PAYMENT HISTORY */}
            <React.Suspense
                fallback={<LazyLoader text="Loading History..." />}
            >
                {showHistoryModal && (
                    <PaymentHistoryModal
                        show={showHistoryModal}
                        onClose={() => {
                            setShowHistoryModal(false);
                            setSelectedHistoryPoId(null);
                        }}
                        poId={selectedHistoryPoId}
                    />
                )}
            </React.Suspense>

            {tableLoading ? (
                <div
                    style={{
                        width: "100%",
                        height: "calc(100vh - 80px)",
                        minHeight: "500px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ffffff"
                    }}
                >
                    <Loader />
                </div>
            ) : (

                <div className={`row ${showApproveModal ? "billing-blur" : ""}`}>
                    <div className="col-xl-12">

                        {/* FILTER */}
                        {open && (

                            <div className="floating-filter-wrapper">
                                <div className="filter cm-content-box box-primary filter-compact glass-filter floating-filter">
                                    <div className="content-title filter-title-clean d-flex justify-content-between align-items-center filter-title-compact">
                                        <div className="cpa">
                                            <i className="fas fa-filter me-2 text-muted"></i>
                                            <span className="text-dark">Filter</span>
                                        </div>

                                        <div>
                                            <Link
                                                to="#"
                                                className="SlideToolHeader"
                                                onClick={() => setOpen(!open)}
                                            >
                                                <i
                                                    className="fas fa-angle-down text-white"
                                                    style={{
                                                        transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                                        transition: "0.3s"
                                                    }}
                                                ></i>
                                            </Link>
                                        </div>

                                    </div>

                                    <Collapse in={open}>
                                        <div className="card-body filter-body-compact">

                                            <div className="row g-2 align-items-center">

                                                {/* PO */}
                                                <div className="col-xl-2 mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm custom-input"
                                                        placeholder="PO Number"
                                                        value={filters.po}
                                                        onChange={(e) => {
                                                            handleFilterChange(
                                                                "po",
                                                                e.target.value,
                                                                (val) => setFilters({ ...filters, po: val })
                                                            );
                                                        }}
                                                    />
                                                </div>

                                                {/* BILL */}
                                                <div className="col-xl-2 mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm custom-input"
                                                        placeholder="Bill Number"
                                                        value={filters.billNo}
                                                        onChange={(e) => {
                                                            handleFilterChange(
                                                                "billNo",
                                                                e.target.value,
                                                                (val) => setFilters({ ...filters, billNo: val })
                                                            );
                                                        }}
                                                    />
                                                </div>



                                                {/* SUPPLIER */}
                                                <div className="col-xl-3 mb-3">
                                                    <Select
                                                        isMulti
                                                        classNamePrefix="custom-react-select"
                                                        placeholder="Supplier"
                                                        options={supplierOptions}
                                                        isLoading={supplierLoading}   // 🔥 ADD THIS
                                                        isDisabled={supplierLoading}  // 🔥 OPTIONAL (prevents click)
                                                        value={supplierOptions.filter(opt =>
                                                            filters.supplier.includes(opt.value)
                                                        )}
                                                        onChange={(opts) => {
                                                            const values = opts ? opts.map(o => o.value) : [];

                                                            handleFilterChange(
                                                                "supplier",
                                                                values,
                                                                (val) => setFilters({ ...filters, supplier: val })
                                                            );
                                                        }}
                                                        isClearable
                                                    />
                                                </div>

                                                {/* STORE */}
                                                <div className="col-xl-3 mb-3">
                                                    <Select
                                                        classNamePrefix="custom-react-select"
                                                        placeholder="Store"
                                                        options={storeOptions}
                                                        isLoading={storeLoading}   // 🔥 ADD THIS
                                                        isDisabled={storeLoading}
                                                        value={storeOptions.find(opt => opt.value === filters.store) || null}
                                                        onChange={(opt) => {
                                                            handleFilterChange(
                                                                "store",
                                                                opt?.value || "",
                                                                (val) => setFilters({ ...filters, store: val })
                                                            );
                                                        }}
                                                        isClearable
                                                    />
                                                </div>

                                            </div>
                                            <div className="row">

                                                {/* CRITERIA */}
                                                <div className="col-xl-6 mb-3">
                                                    <select
                                                        className="form-control form-control-sm"
                                                        value={filters.amountCriteria}
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            handleFilterChange(
                                                                "amount",
                                                                value,
                                                                () => setFilters({
                                                                    ...filters,
                                                                    amountCriteria: value,
                                                                    amount: ""
                                                                })
                                                            );
                                                        }}
                                                    >
                                                        <option value="">Select Amount Criteria</option>
                                                        <option value="gt">Greater Than</option>
                                                        <option value="lt">Less Than</option>
                                                        <option value="gte">Greater Than Equal To</option>
                                                        <option value="lte">Less Than Equal To</option>
                                                        <option value="eq">Equal To</option>
                                                    </select>
                                                </div>

                                                {/* AMOUNT INPUT */}
                                                <div className="col-xl-6 mb-3">
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm custom-input"
                                                        placeholder="Enter Amount"
                                                        disabled={!filters.amountCriteria}
                                                        value={filters.amount}
                                                        onChange={(e) => {
                                                            handleFilterChange(
                                                                "amount",
                                                                e.target.value,
                                                                (val) => setFilters({
                                                                    ...filters,
                                                                    amount: val
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </div>

                                            </div>

                                            {/* 🔥 ROW 3 (SEPARATE RANGE + BUTTONS) */}
                                            <div className="row">

                                                {/* ✅ PO CREATION DATE RANGE */}
                                                <div className="col-xl-6 mb-3">

                                                    <label className="fw-bold mb-2 d-block text-center">
                                                        PO Creation Date
                                                    </label>

                                                    <div className="row g-2">

                                                        {/* FROM DATE */}
                                                        <div className="col-md-6">
                                                            <label
                                                                className="mb-1 d-block text-muted"
                                                                style={{ fontSize: "12px" }}
                                                            >
                                                                From Date
                                                            </label>

                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                value={filters.fromDate}
                                                                max={filters.toDate || undefined}
                                                                onChange={(e) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        fromDate: e.target.value
                                                                    })
                                                                }
                                                            />
                                                        </div>

                                                        {/* TO DATE */}
                                                        <div className="col-md-6">
                                                            <label
                                                                className="mb-1 d-block text-muted"
                                                                style={{ fontSize: "12px" }}
                                                            >
                                                                To Date
                                                            </label>

                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                value={filters.toDate}
                                                                min={filters.fromDate || undefined}
                                                                onChange={(e) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        toDate: e.target.value
                                                                    })
                                                                }
                                                            />
                                                        </div>

                                                    </div>

                                                </div>
                                                {/* ✅ BILL DATE RANGE */}
                                                <div className="col-xl-6 mb-3">

                                                    <label className="fw-bold mb-2 d-block text-center">
                                                        Bill Date
                                                    </label>

                                                    <div className="row g-2">

                                                        {/* FROM DATE */}
                                                        <div className="col-md-6">
                                                            <label
                                                                className="mb-1 d-block text-muted"
                                                                style={{ fontSize: "12px" }}
                                                            >
                                                                From Date
                                                            </label>

                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                value={filters.billingFromDate}
                                                                max={filters.billingToDate || undefined}
                                                                onChange={(e) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        billingFromDate: e.target.value
                                                                    })
                                                                }
                                                            />
                                                        </div>

                                                        {/* TO DATE */}
                                                        <div className="col-md-6">
                                                            <label
                                                                className="mb-1 d-block text-muted"
                                                                style={{ fontSize: "12px" }}
                                                            >
                                                                To Date
                                                            </label>

                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                value={filters.billingToDate}
                                                                min={filters.billingFromDate || undefined}
                                                                onChange={(e) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        billingToDate: e.target.value
                                                                    })
                                                                }
                                                            />
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* ✅ BUTTONS */}
                                                <div className="col-xl-12">
                                                    <div className="d-flex justify-content-center gap-2 mt-2">
                                                        <button
                                                            className="btn btn-sm btn-primary"
                                                            onClick={handleSearch}
                                                        >
                                                            Search
                                                        </button>

                                                        <button
                                                            className="btn btn-sm btn-secondary"
                                                            onClick={async () => {

                                                                const resetFilters = {
                                                                    billNo: "",
                                                                    supplier: [],
                                                                    po: "",
                                                                    amount: "",
                                                                    amountCriteria: "",
                                                                    fromDate: "",
                                                                    toDate: "",
                                                                    billingFromDate: "",
                                                                    billingToDate: "",
                                                                    store: ""
                                                                };

                                                                // Clear filter values
                                                                setFilters(resetFilters);

                                                                // Clear table-side filters also
                                                                setSearch("");
                                                                setStatusFilter("");
                                                                setSupplierFilterUI("");
                                                                setStoreFilterUI("");
                                                                setPoTypeFilterUI("");

                                                                setActiveFilterKey(null);
                                                                setIsSearched(false);
                                                                setOpen(false);

                                                                // Fetch normal Billing data again
                                                                await fetchData({
                                                                    ...resetFilters,
                                                                    viewType: "new"
                                                                });
                                                            }}
                                                        >
                                                            Reset
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </Collapse>
                                </div>
                            </div>

                        )}

                        {/* 🔥 BACKDROP ADD HERE */}
                        {open && (
                            <div
                                className="filter-backdrop"
                                onClick={() => setOpen(false)}
                            />
                        )}

                        {/* TABLE */}
                        <div className="filter cm-content-box box-primary table-compact">
                            <div className="content-title billing-header">

                                {/* LEFT */}
                                <div className="billing-header-left">
                                    <i className="fa fa-list me-2" aria-hidden="true"></i>
                                    {dashboardHeading}
                                    <span className="badge bg-orange ms-2">
                                        {totalResults}
                                    </span>
                                </div>

                                {/* CENTER INFO */}
                                {tableData.length > 0 && (
                                    <div className="billing-header-center">
                                        {!isSearched ? (
                                            <>ℹ️ Showing Billing Pending Data</>
                                        ) : (
                                            <>🔍 Showing filtered results</>
                                        )}
                                    </div>
                                )}

                                {/* RIGHT */}
                                <div className="billing-header-right d-flex align-items-center gap-2">

                                    {/* 🔥 FILTER ICON */}
                                    {/* BACK TO BILLING PENDING DATA */}
                                    {isSearched && (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-secondary"
                                            title="Back to Billing Pending Data"
                                            onClick={async () => {
                                                const resetFilters = {
                                                    billNo: "",
                                                    supplier: [],
                                                    po: "",
                                                    amount: "",
                                                    amountCriteria: "",
                                                    fromDate: "",
                                                    toDate: "",
                                                    billingFromDate: "",
                                                    billingToDate: "",
                                                    store: ""
                                                };

                                                setFilters(resetFilters);

                                                setSearch("");
                                                setStatusFilter("");
                                                setSupplierFilterUI("");
                                                setStoreFilterUI("");
                                                setPoTypeFilterUI("");

                                                setActiveFilterKey(null);
                                                setIsSearched(false);
                                                setOpen(false);

                                                await fetchData({
                                                    ...resetFilters,
                                                    viewType: "new"
                                                });
                                            }}
                                        >
                                            <i className="fas fa-arrow-left me-1"></i>
                                            Back
                                        </button>
                                    )}
                                    <i
                                        className="fas fa-filter"
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "16px",
                                            color: open ? "#0d6efd" : "#6c757d",
                                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                            transition: "0.3s"
                                        }}
                                        title="Filter"
                                        onClick={() => setOpen(prev => !prev)}
                                    ></i>

                                    {/* EXISTING COLLAPSE */}
                                    <Link
                                        to={"#"}
                                        className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                        onClick={() => setOpen2(!open2)}
                                    >
                                        <i className="fas fa-angle-up"></i>
                                    </Link>

                                </div>

                            </div>
                            <Collapse in={open2}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="row mb-1 g-1 align-items-center filter-row-modern compact">

                                            {/* SEARCH */}
                                            <div className="col-md-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search Bill / MRV / PO / Req / Supplier / Amount"
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>

                                            {/* STATUS */}
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={statusFilter}
                                                    onChange={(e) => setStatusFilter(e.target.value)}
                                                >
                                                    <option value="">Status</option>
                                                    {statusOptionsUI.map((s, i) => (
                                                        <option key={i}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* SUPPLIER */}
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={supplierFilterUI}
                                                    onChange={(e) =>
                                                        handleMainTableFilter(
                                                            "supplierFilter",
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">Supplier</option>
                                                    {supplierOptionsUI.map((s, i) => (
                                                        <option key={i}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* STORE */}
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={storeFilterUI}
                                                    onChange={(e) =>
                                                        handleMainTableFilter(
                                                            "storeFilter",
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">Store</option>
                                                    {storeOptionsUI.map((s, i) => (
                                                        <option key={i}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* PO TYPE */}
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={poTypeFilterUI}
                                                    onChange={(e) =>
                                                        handleMainTableFilter(
                                                            "poTypeFilter",
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">PO Type</option>

                                                    {poTypeOptionsUI.map((p, i) => (
                                                        <option key={i}>{p}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* CLEAR */}
                                            <div className="col-md-1 d-flex align-items-center justify-content-center">
                                                {(search || statusFilter || supplierFilterUI || storeFilterUI || poTypeFilterUI) && (
                                                    <button
                                                        className="btn custom-clear-btn"
                                                        onClick={async () => {

                                                            // Clear UI filters
                                                            setSearch("");
                                                            setStatusFilter("");
                                                            setSupplierFilterUI("");
                                                            setStoreFilterUI("");
                                                            setPoTypeFilterUI("");

                                                            // Return to first page
                                                            setActivePage(0);

                                                            // Fetch data again without table filters
                                                            await fetchData({
                                                                ...(isSearched ? filters : {}),

                                                                viewType: isSearched
                                                                    ? "paymentSearch"
                                                                    : "new",

                                                                page: 1,
                                                                limit: pageLimit,

                                                                search: "",
                                                                statusFilter: "",
                                                                supplierFilter: "",
                                                                storeFilter: "",
                                                                poTypeFilter: ""
                                                            });
                                                        }}
                                                    >
                                                        Clear
                                                    </button>
                                                )}
                                            </div>

                                        </div>
                                        <div className="table-responsive" style={{ position: "relative" }}>

                                            {/* 🔥 OVERLAY LOADER */}
                                            {overlayLoading && (
                                                <div className="overlay-loader">
                                                    <div className="custom-loader"></div>
                                                    <div className="mt-2">Updating...</div>
                                                </div>
                                            )}

                                            <div
                                                id="content_wrapper"
                                                className="dataTables_wrapper no-footer"
                                            >



                                                <div className="table-scroll-container">

                                                    {/* 🔥 LEFT ARROW */}
                                                    {/* LEFT */}
                                                    {showLeft && (
                                                        <div
                                                            className="table-arrow left"
                                                            onClick={() => scrollTable("left")}
                                                        >
                                                            <i className="fas fa-chevron-left"></i>
                                                        </div>
                                                    )}

                                                    {/* RIGHT */}
                                                    {showRight && (
                                                        <div
                                                            className="table-arrow right"
                                                            onClick={() => scrollTable("right")}
                                                        >
                                                            <i className={`fas ${isAtEnd ? "fa-chevron-left" : "fa-chevron-right"}`}></i>
                                                        </div>
                                                    )}

                                                    <div className="po-table-wrapper" id="billingTableScroll">
                                                        <table className="table custom-table-new align-middle">
                                                            <thead
                                                                style={{
                                                                    position: "sticky",
                                                                    top: 0,
                                                                    background: "#eef1f5",
                                                                    borderBottom: "2px solid #dcdcdc",
                                                                    zIndex: 2,
                                                                }}
                                                            >
                                                                <tr>
                                                                    <th>S.No</th>

                                                                    {/* ✅ ACTION AFTER S.NO */}
                                                                    <th className="text-center">Action</th>

                                                                    <th>Store</th>

                                                                    <th>Status</th>

                                                                    <th>Bill Title</th>

                                                                    <th>Bill No</th> {/* 🔥 swapped */}

                                                                    <th
                                                                        onClick={() => handleSort("billingDate")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        Bill Date 🔄
                                                                    </th>

                                                                    <th>MRV No</th>

                                                                    <th>Requisition</th>

                                                                    <th
                                                                        style={{
                                                                            width: "270px",
                                                                            minWidth: "270px",
                                                                            maxWidth: "270px"
                                                                        }}
                                                                    >
                                                                        <div style={{ textAlign: "center" }}>
                                                                            PO Details
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                fontSize: "11px",
                                                                                marginTop: "3px",
                                                                                whiteSpace: "nowrap"
                                                                            }}
                                                                        >
                                                                            <span
                                                                                onClick={() => handleSort("poNumber")}
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    marginRight: "8px"
                                                                                }}
                                                                                title="Sort by PO Number"
                                                                            >
                                                                                PO 🔄
                                                                            </span>

                                                                            <span
                                                                                onClick={() => handleSort("totalAmount")}
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    marginRight: "8px"
                                                                                }}
                                                                                title="Sort by PO Amount"
                                                                            >
                                                                                Amount 🔄
                                                                            </span>

                                                                            <span
                                                                                onClick={() => handleSort("createdAt")}
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    marginRight: "8px"
                                                                                }}
                                                                                title="Sort by Created Date"
                                                                            >
                                                                                Created 🔄
                                                                            </span>

                                                                            <span
                                                                                onClick={() => handleSort("updatedAt")}
                                                                                style={{
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                title="Sort by Updated Date"
                                                                            >
                                                                                Updated 🔄
                                                                            </span>
                                                                        </div>
                                                                    </th>

                                                                    <th
                                                                        onClick={() => handleSort("billAmount")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        Bill Amount 🔄
                                                                    </th>

                                                                    <th
                                                                        onClick={() => handleSort("otherCharges")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        Other Charges 🔄
                                                                    </th>

                                                                    <th
                                                                        onClick={() => handleSort("failedSupplyCount")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        Delivery Failed 🔄
                                                                    </th>

                                                                    <th>Other Doc</th>



                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {filteredData.length > 0 ? (
                                                                    filteredData.map((item, index) => (
                                                                        <tr key={item._id}>

                                                                            {/* S.NO */}
                                                                            <td>
                                                                                {(activePage * pageLimit) + index + 1}
                                                                            </td>

                                                                            {/* ACTION */}
                                                                            <td className="text-center">

                                                                                <i
                                                                                    className="fa fa-check-circle text-success"
                                                                                    style={{ cursor: "pointer", fontSize: "18px" }}
                                                                                    title="Approve"
                                                                                    onClick={() => handleBillingApproveClick(item)}
                                                                                ></i>

                                                                            </td>


                                                                            {/* STORE */}
                                                                            <td className="scrollable-description">
                                                                                {item?.storeName || ''}
                                                                            </td>


                                                                            {/* 🔥 STATUS */}
                                                                            <td className="scrollable-description">

                                                                                <div>

                                                                                    <strong
                                                                                        style={{
                                                                                            cursor: "pointer",
                                                                                            color: "#0d6efd",
                                                                                            textDecoration: "underline"
                                                                                        }}
                                                                                        onClick={() => handleHistoryClick(item.poId)}
                                                                                    >
                                                                                        {getStatusLabel(item.paymentFlowStatus)}
                                                                                    </strong>

                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        color: "#6b7280",
                                                                                        fontSize: "12px"
                                                                                    }}
                                                                                >
                                                                                    Click to View History
                                                                                </div>

                                                                            </td>


                                                                            {/* ✅ BILL TITLE */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0
                                                                                    ? item.mrvDetails.map((m, i) => (
                                                                                        <div key={i}>
                                                                                            {m?.billingTitle?.trim()
                                                                                                ? m.billingTitle
                                                                                                : "-"}
                                                                                        </div>
                                                                                    ))
                                                                                    : "-"
                                                                                }
                                                                            </td>


                                                                            {/* ✅ BILL NUMBER */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0 ? (
                                                                                    <>
                                                                                        {/* ✅ SINGLE BILL */}
                                                                                        {item.mrvDetails.map((m, i) => (
                                                                                            <div
                                                                                                key={i}
                                                                                                className="d-flex align-items-center gap-2"
                                                                                            >
                                                                                                <span>
                                                                                                    {m?.billingNo || "-"}
                                                                                                </span>

                                                                                                {m?.image && (
                                                                                                    <i
                                                                                                        className="fa fa-eye text-primary"
                                                                                                        title="View Bill"
                                                                                                        style={{
                                                                                                            cursor: "pointer",
                                                                                                            fontSize: "14px"
                                                                                                        }}
                                                                                                        onClick={() => handleBillPreview(m)}
                                                                                                    />
                                                                                                )}
                                                                                            </div>
                                                                                        ))}

                                                                                        {/* ✅ MULTI BILL ACTION - KEEP EXISTING */}
                                                                                        {item.mrvDetails.filter(m => m.image).length > 1 && (
                                                                                            <div
                                                                                                className="table-action-link"
                                                                                                onClick={() =>
                                                                                                    handleMultiBillPreview(item.mrvDetails)
                                                                                                }
                                                                                            >
                                                                                                + View All (
                                                                                                {item.mrvDetails.filter(m => m.image).length}
                                                                                                )
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                            </td>


                                                                            {/* ✅ BILL DATE */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0
                                                                                    ? item.mrvDetails.map((m, i) => (
                                                                                        <div key={i}>
                                                                                            {m?.billingDate
                                                                                                ? new Date(m.billingDate).toLocaleDateString("en-GB")
                                                                                                : "-"
                                                                                            }
                                                                                        </div>
                                                                                    ))
                                                                                    : "-"
                                                                                }
                                                                            </td>


                                                                            {/* ✅ MRV NUMBERS */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0 ? (
                                                                                    <>
                                                                                        {/* ✅ SINGLE MRV */}
                                                                                        {item.mrvDetails.map((m, i) => (
                                                                                            <div
                                                                                                key={i}
                                                                                                className="d-flex align-items-center gap-2"
                                                                                            >
                                                                                                <span>
                                                                                                    {m?.mrvNo || "-"}
                                                                                                </span>

                                                                                                {m?._id && (
                                                                                                    <i
                                                                                                        className="fa fa-eye text-primary"
                                                                                                        title="View MRV"
                                                                                                        style={{
                                                                                                            cursor: "pointer",
                                                                                                            fontSize: "14px"
                                                                                                        }}
                                                                                                        onClick={() =>
                                                                                                            handleMRVPreview(m._id)
                                                                                                        }
                                                                                                    />
                                                                                                )}
                                                                                            </div>
                                                                                        ))}

                                                                                        {/* ✅ MULTI MRV ACTION - KEEP EXISTING */}
                                                                                        {item.mrvDetails.filter(m => m?._id).length > 1 && (
                                                                                            <div
                                                                                                className="table-action-link"
                                                                                                onClick={() =>
                                                                                                    handleMultiMRVPreview(
                                                                                                        item.mrvDetails
                                                                                                            .filter(m => m?._id)
                                                                                                            .map(m => m._id)
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                + View All (
                                                                                                {item.mrvDetails.filter(m => m?._id).length}
                                                                                                )
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                            </td>


                                                                            {/* REQUISITION */}
                                                                            <td>
                                                                                <div className="d-flex align-items-center gap-2">

                                                                                    <span>
                                                                                        {item?.requisitionNo || "-"}
                                                                                    </span>

                                                                                    {item?.requisitionNo && (
                                                                                        <i
                                                                                            className="fa fa-eye text-primary"
                                                                                            title="View Requisition"
                                                                                            style={{
                                                                                                cursor: "pointer",
                                                                                                fontSize: "14px"
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                handleRequisitionPreview(
                                                                                                    item?.requisitionId
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    )}

                                                                                </div>
                                                                            </td>
                                                                            {/* PO DETAILS */}
                                                                            <td
                                                                                className="align-middle"
                                                                                style={{
                                                                                    textAlign: "left",
                                                                                    fontWeight: "normal",
                                                                                    width: "270px",
                                                                                    minWidth: "270px",
                                                                                    maxWidth: "270px",
                                                                                    paddingLeft: "10px",
                                                                                    paddingRight: "10px",
                                                                                    paddingTop: "5px",
                                                                                    paddingBottom: "5px"
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        textAlign: "left",
                                                                                        lineHeight: "2.0",
                                                                                        fontWeight: "normal",
                                                                                        fontSize: "13px"
                                                                                    }}
                                                                                >

                                                                                    {/* PO NUMBER */}
                                                                                    <div
                                                                                        className="d-flex align-items-center justify-content-start gap-2"
                                                                                        style={{ color: "#4b5563" }}
                                                                                    >
                                                                                        <span>PO:</span>

                                                                                        <span>
                                                                                            {item?.poNumber || "-"}
                                                                                        </span>

                                                                                        {item?.poNumber && (
                                                                                            <i
                                                                                                className="fa fa-eye"
                                                                                                title="View PO"
                                                                                                style={{
                                                                                                    cursor: "pointer",
                                                                                                    fontSize: "14px",
                                                                                                    color: "#4db6ac"
                                                                                                }}
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    handlePOClick(item);
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </div>

                                                                                    {/* TYPE */}
                                                                                    <div style={{ color: "#7c8798" }}>
                                                                                        <span>Type:</span>{" "}
                                                                                        <span>{item.poType || "Normal"}</span>
                                                                                    </div>

                                                                                    {/* SUPPLIER */}
                                                                                    <div
                                                                                        style={{
                                                                                            color: "#4b5563",
                                                                                            whiteSpace: "normal",
                                                                                            overflowWrap: "break-word"
                                                                                        }}
                                                                                    >
                                                                                        <span>Supplier:</span>{" "}
                                                                                        <span>{item.supplierName || "-"}</span>
                                                                                    </div>

                                                                                    {/* AMOUNT */}
                                                                                    <div style={{ color: "#7c8798" }}>
                                                                                        <span>Amount:</span>{" "}
                                                                                        <span>
                                                                                            ₹{" "}
                                                                                            {item.totalAmount !== undefined &&
                                                                                                item.totalAmount !== null
                                                                                                ? Number(item.totalAmount).toFixed(2)
                                                                                                : "-"}
                                                                                        </span>
                                                                                    </div>

                                                                                    {/* ADVANCE DETAILS */}
                                                                                    {(
                                                                                        (item.advanceRentalAmount ?? 0) > 0 ||
                                                                                        (item.advanceRentalPercent ?? 0) > 0
                                                                                    ) && (
                                                                                            <>
                                                                                                <div style={{ color: "#4b5563" }}>
                                                                                                    <span>Advance:</span>{" "}
                                                                                                    ₹{" "}
                                                                                                    {Number(
                                                                                                        item.advanceRentalAmount || 0
                                                                                                    ).toFixed(2)}
                                                                                                </div>

                                                                                                <div style={{ color: "#7c8798" }}>
                                                                                                    <span>Advance %:</span>{" "}
                                                                                                    {item.advanceRentalPercent || 0}%
                                                                                                </div>
                                                                                            </>
                                                                                        )}

                                                                                    {/* STATUS */}
                                                                                    <div style={{ color: "#4b5563" }}>
                                                                                        <span>Status:</span>{" "}
                                                                                        <span>
                                                                                            {getStatusLabel(item.paymentFlowStatus)}
                                                                                        </span>
                                                                                    </div>

                                                                                    {/* CREATED */}
                                                                                    <div style={{ color: "#7c8798" }}>
                                                                                        <span>Created:</span>{" "}
                                                                                        <span>
                                                                                            {formatDateTime(item.createdAt)}
                                                                                        </span>
                                                                                    </div>

                                                                                    {/* UPDATED */}
                                                                                    <div style={{ color: "#4b5563" }}>
                                                                                        <span>Updated:</span>{" "}
                                                                                        <span>
                                                                                            {formatDateTime(item.updatedAt)}
                                                                                        </span>
                                                                                    </div>

                                                                                </div>
                                                                            </td>


                                                                            {/* ✅ BILL AMOUNT */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0
                                                                                    ? item.mrvDetails.map((m, i) => (
                                                                                        <div key={i}>
                                                                                            {m?.totalAmount ?? "-"}
                                                                                        </div>
                                                                                    ))
                                                                                    : "-"
                                                                                }
                                                                            </td>


                                                                            {/* ✅ OTHER CHARGES */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0
                                                                                    ? item.mrvDetails.map((m, i) => (
                                                                                        <div key={i}>
                                                                                            {m?.otherCharges ?? "-"}
                                                                                        </div>
                                                                                    ))
                                                                                    : "-"
                                                                                }
                                                                            </td>


                                                                            {/* DELIVERY FAILED */}
                                                                            <td>
                                                                                {item?.failedSupplyCount > 0 ? (
                                                                                    <span
                                                                                        title="Click to view Requisition"
                                                                                        style={{
                                                                                            cursor: "pointer",
                                                                                            background: "#fff4e5",
                                                                                            color: "#92400e",
                                                                                            padding: "3px 8px",
                                                                                            borderRadius: "6px",
                                                                                            fontSize: "12px",
                                                                                            fontWeight: "500",
                                                                                            display: "inline-block"
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (item?.requisitionId) {
                                                                                                handleFailedRequisitionPreview(
                                                                                                    item.requisitionId,
                                                                                                    item.poNumber
                                                                                                )
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {item.failedSupplyCount}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span style={{ color: "#9ca3af" }}>0</span>
                                                                                )}
                                                                            </td>


                                                                            {/* OTHER DOC */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0 ? (() => {

                                                                                    // ✅ check if ANY doc exists
                                                                                    const hasAnyDoc = item.mrvDetails.some(m => m.otherDoc);

                                                                                    // ❌ if none → show single NA
                                                                                    if (!hasAnyDoc) {
                                                                                        return <span style={{ color: "gray" }}>Not Available</span>;
                                                                                    }

                                                                                    // ✅ if exists → show only available docs
                                                                                    return item.mrvDetails
                                                                                        .filter(m => m.otherDoc)
                                                                                        .map((m, i) => (
                                                                                            <div key={i}>
                                                                                                <span
                                                                                                    style={{
                                                                                                        color: "green",
                                                                                                        cursor: "pointer",
                                                                                                        textDecoration: "underline"
                                                                                                    }}
                                                                                                    onClick={() => handleOtherDocPreview(m)}
                                                                                                >
                                                                                                    {`Doc ${i + 1}`}
                                                                                                </span>
                                                                                            </div>
                                                                                        ));

                                                                                })() : "-"}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="15" className="text-center text-muted py-4">
                                                                            No records found
                                                                        </td>
                                                                    </tr>
                                                                )
                                                                }
                                                            </tbody>

                                                        </table>

                                                    </div>



                                                    {/* ==========================================
    PAGINATION - OUTSIDE TABLE SCROLL
========================================== */}
                                                    <div
                                                        className="d-sm-flex text-center justify-content-between align-items-center mt-3 px-2"
                                                        style={{
                                                            width: "100%",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        <div className="dataTables_info">
                                                            Showing{" "}

                                                            {totalResults > 0
                                                                ? activePage * pageLimit + 1
                                                                : 0}

                                                            {" "}to{" "}

                                                            {Math.min(
                                                                (activePage + 1) * pageLimit,
                                                                totalResults
                                                            )}

                                                            {" "}of{" "}

                                                            {totalResults}

                                                            {" "}entries
                                                        </div>

                                                        {totalPages > 0 && (
                                                            <Pagination
                                                                activePage={activePage}
                                                                totalPages={totalPages}
                                                                onPageChange={handlePageChange}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                    </div>
                </div>

            )}

        </>
    );
};

export default BillingTeam;